var _path, _path2, _path3, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgAf = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.331h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#496e2d",
  d: "M330.207 85.331H512v341.337H330.207z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.331h181.793v341.337H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#ffda44"
}, /*#__PURE__*/React.createElement("path", {
  d: "M256 196.632c-32.785 0-59.362 26.577-59.362 59.362s26.577 59.362 59.362 59.362 59.362-26.577 59.362-59.362-26.577-59.362-59.362-59.362zm0 96.463c-20.491 0-37.101-16.611-37.101-37.101s16.61-37.101 37.101-37.101 37.101 16.61 37.101 37.101-16.61 37.101-37.101 37.101z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256 233.734c-8.196 0-14.84 6.644-14.84 14.84v22.261h29.682v-22.261c-.002-8.197-6.646-14.84-14.842-14.84z"
}))));

export default SvgAf;